import * as React from 'react';
import { getAjaxhelper, isNull, momentWrapper, momentDuration } from '../utils/index';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
import { HotelBedCatalogData, BookingData, HotelBedBookingData, HotelBedBookingCancelationData, HotelBedData } from '../shared/index';
import { CategoryHotels } from '../core/CategoryHotels';
import { getHotelSlug, FormatterUtils, makeid } from '../core/Const';
import { SearchForm } from '../core/SearchForm';
import { RecentBlog } from '../core/RecentBlog';
import { Link } from 'react-router-dom';
export interface ResponseBooking {
    id?: number;
    hotelDetail?: HotelBedCatalogData.Hotel;
    hotelPhone?: HotelBedCatalogData.HotelsPhones[];
    bookingData?: HotelBedBookingData.BookingRequestResponse;
    paymentData?: any;
    customerData?: BookingData.Customer;
    statusCode?: string;
    errorMessage?: {
        booking?: string,
        payment?: string
    };
    curencyCode?: string;
    curencyValue?: number;
    currentBookingCancelationId?: number;
    
}

export interface BookingCancelationConfirmationProps extends BaseComponentProps {
    bookingId: string;
    lang: string;
    getHotels: (lang: string, page: number, count: number, filter: HotelBedData.SearchFilter, externalFilter: HotelBedData.ExternalFilter) => any;
    initialFilter: HotelBedData.SearchFilter;
}

export interface BookingCancelationConfirmationState extends BaseComponentState {
    /**
     * flag untuk panel ada error
     */
    haveError: boolean;
    /**
     * state dari panel. 
     */
    panelState: 'requesting' | 'complete' | 'error' | 'waiting' | 'canceled';
    errorMessage?: string;
    errorCode?: string;
    /**
     * data cancelation
     */
    cancelationData?: HotelBedBookingCancelationData.Response.BookingCancellationRS;
    bookingData?: HotelBedBookingData.BookingRequestResponse;
    paymentData?: any;
    customerData?: BookingData.Customer;
    hotelDetail?: HotelBedCatalogData.Hotel;
    hotelPhones?: HotelBedCatalogData.HotelsPhones[];
    curencyCode?: string;
    curencyValue?: number;
    currentBookingCancelationId?: number;
}

export class BookingCancelationConfirmation extends BaseComponent<BookingCancelationConfirmationProps, BookingCancelationConfirmationState> {

    /**
     * field pada props untuk di check ada perubahan atau tidak
     */
    static FIELD_COMPARED_PROPS: string[] = ['bookingId'];
    /**
     * field yang di compare pada state untuk di check ada perubahan atau tidak
     */
    static FIELD_COMPARED_STATE: string[] = ['haveError', 'panelState'];

    timeout: any = null;
    recLagi: number = 0;
    constructor(props: BookingCancelationConfirmationProps) {
        super(props);
        this.state = {
            panelState: 'requesting',
            haveError: false
        };
    }
    componentDidMount() {
        this.sendCancelationSimulationRequest();
    }

    componentWillUnmount() {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    }

    sendCancelationSimulationRequest() {
        console.log('[BookingCancelSimulationPanel.getBookingDetail]request starting');
        getAjaxhelper().post("/dynamics/hb-api/booking-confirm", {
            bookingId: this.props.bookingId
        }).then(data => {
            if (!isNull(data)) {
                this.setStateHelper(
                    stBooking => {
                        stBooking.bookingData = data.bookingData;
                        stBooking.customerData = data.customerData;
                        stBooking.paymentData = data.paymentData;
                        stBooking.hotelDetail = data.hotelDetail;
                        stBooking.hotelPhones = data.hotelPhone;
                        stBooking.curencyCode = data.curencyCode;
                        stBooking.curencyValue = data.curencyValue;
                        stBooking.currentBookingCancelationId = data.currentBookingCancelationId;
                    },
                    () => {
                        console.log('[BookingCancelSimulationPanel.sendCancelationSimulationRequest]request starting');
                        getAjaxhelper().get(`/dynamics/booking-cancelation-sumulation/${data.id}`).then(d => {
                            this.setStateHelper(
                                st => {
                                    st.cancelationData = d;
                                    st.panelState = 'complete';
                                }
                            );
                        }).catch(exc => {
                            this.setStateHelper(
                                st => {
                                    st.haveError = true;
                                    st.errorCode = exc.code;
                                    st.errorMessage = exc.message;
                                }
                            );
                        });
                    });
            }
        }).catch(exc => {
            this.setStateHelper(stBooking => {
                stBooking.haveError = true;
                stBooking.errorCode = exc.code;
                stBooking.errorMessage = exc.message;
            });

        });
    }
    shouldComponentUpdate(nextProps: BookingCancelationConfirmationProps, nextState: BookingCancelationConfirmationState): boolean {
        if (this.compareForShouldComponentUpdateStateOrProp(BookingCancelationConfirmation.FIELD_COMPARED_PROPS, this.props, nextProps)) {
            return true;
        }
        if (this.compareForShouldComponentUpdateStateOrProp(BookingCancelationConfirmation.FIELD_COMPARED_STATE, this.state, nextState)) {
            return true;
        }
        return false;

    }
    render() {

        if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        }  
        if (this.state.haveError) {
            return this.renderErrorPanel();
        }
        if (this.state.panelState === 'requesting' || this.state.panelState === 'waiting') {
            return this.renderLoadingPanel();
        } else if (this.state.panelState === 'complete') {
            return this.renderSimulationCompletePanel();
        } else if (this.state.panelState === 'canceled') {
            return this.renderCanceledPanel();
        }
        return <span />;

    }
    renderCanceledPanel: () => any = () => {
        return (
            <section className="container-fluid">
                <div style={{ marginTop: 140 }} />
                <div className="container">
                    <div className='alert alert-success'>
                        <strong>Cancelation Success</strong><br />
                        Your booking have success for cancelation, for make sure please <Link to={`/voucher-confirmed?id=${this.props.bookingId}`}>CLICK HERE</Link> for check you voucher hotel status
                    </div>
                </div>
            </section>
        );
    }

    renderRoomDetail: (rooms: HotelBedBookingData.BookingResponseRoomData[]) => any = (rooms: HotelBedBookingData.BookingResponseRoomData[]) => {
        let ret: any[] = [];
        rooms.forEach(room => {
            // let component: any = <span />;
            let rateComp: any[] = [];
            room.rates!.forEach(rate => {
                let cancelPolice: any[] = [];
                rate.cancellationPolicies!.forEach(cancel => {
                    cancelPolice.push(
                        <span key={makeid()}> From : {momentWrapper(cancel.from).format('MMMM Do YYYY') + ' Amount: ' + cancel.amount} </span>
                    );
                    cancelPolice.push(
                        <br key={makeid()} />
                    );
                });

                let fr = momentWrapper(this.state.bookingData!.hotel.checkIn);
                let to = momentWrapper(this.state.bookingData!.hotel.checkOut);
                let night = momentDuration(to.diff(fr)).as('day');
                rateComp.push(
                    <tr key={makeid()} style={{ lineHeight: '40px' }}>
                        <td key={makeid()} style={{ paddingLeft: 10 }}> {room.name} </td>
                        <td key={makeid()} style={{ paddingLeft: 10 }}> {night} Night/s</td>
                        <td key={makeid()} style={{ paddingLeft: 10 }}> {rate.boardName} </td>
                        <td key={makeid()} style={{ paddingLeft: 10 }}>{rate.rooms} <i className='fa fa-bed' /> {rate.adults} <i className='fa fa-user' />{rate.children}<i className='fa fa-child' /></td>
                    </tr>
                );
            });

            ret.push(
                <table key={makeid()} className="table table-striped" style={{ marginTop: 0 }}>
                    <thead>
                        <tr>
                            <th>Room Type</th>
                            <th>Number of Night/s</th>
                            <th>Board</th>
                            <th>Detail</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rateComp}
                    </tbody>

                </table>
            );
        });
        return ret;
    }

    renderErrorPanel(): JSX.Element {
        return (
            <section className="container-fluid">
                <div style={{ marginTop: 140 }} />
                <div className="container">
                    <div className='alert alert-danger'>
                        <strong>{this.state.errorCode}</strong><br />
                        {this.state.errorMessage}
                    </div>
                </div>
            </section>
        );
    }
    private renderLoadingPanel(): JSX.Element {
        let waitingText = [];
        if (this.state.panelState === 'requesting') {

            waitingText.push(
                <h5 key={makeid()}>System calculating for cancelation value</h5>
            );
        }
        if (this.state.panelState === 'waiting') {
            waitingText.push(
                <h5 key={makeid()}>System publishing you</h5>
            );
        }
        return (
            <section className="container-fluid">
                <div style={{ marginTop: 140 }} />
                <div className="container">
                    <div className="col-md-9 bg-white" style={{ minHeight: 500, textAlign: "center", paddingTop: '10%' }}>
                        <h4>Please Wait</h4>
                        {waitingText}
                        <div className='loader' />
                    </div>
                    <div className="col-md-3">
                        <h3>Search Hotel</h3>
                        <SearchForm
                            lang={this.props.lang}
                            showtitle={false}
                            style='vertical'
                            count={15}
                            getHotels={this.props.getHotels}
                            externalFilter={{}}
                            filter={this.props.initialFilter}
                            /* key={btoa(JSON.stringify(this.props.initialFilter))} */
                        />
                        <RecentBlog lang={this.props.lang} />
                    </div>
                </div>
            </section>
        );
    }

    private renderSimulationCompletePanel(): JSX.Element {
        let mailto = '';
        if (!isNull(this.state.customerData) && !isNull(this.state.customerData!.email)) {
            mailto = 'mailto:' + this.state.customerData!.email;

        }
        let hotelPhones = [];

        if (!isNull(this.state.hotelPhones)) {
            for (let a of this.state.hotelPhones!) {
                if (a.phoneType === 'FAXNUMBER') {
                    hotelPhones.push(
                        <span key={makeid()}> <i className="fa fa-fax" /> {a.phoneNumber} </span>
                    );
                } else if (a.phoneType === 'PHONEBOOKING') {
                    hotelPhones.push(
                        <span key={makeid()}> <i className="fa fa-headphones" /> {a.phoneNumber} </span>
                    );
                } else {
                    hotelPhones.push(
                        <span key={makeid()}> <i className='fa fa-phone' /> {a.phoneNumber}  </span>
                    );
                }
            }
        }
        return (
            <section className="container-fluid">
                <div style={{ marginTop: 140 }} />
                <div className="container">
                    <div className="col-md-9  bg-white" style={{ padding: '15px 0' }}>
                        <div className='col-md-12 '>
                            <div className='col-md-6'>
                                <h2>E-Voucher <br /> <span style={{ fontSize: '0.5em' }}> Hotel Booking </span></h2>
                            </div>
                            <div className='col-md-6 text-right'>
                                <img src='/assets/images/logo.png' />
                            </div>
                        </div>

                        <div className='col-md-12'>
                            <div className='col-md-4' style={{ paddingTop: 10 }}>
                                <div className='panel-body well'>
                                    <h3>Booking Holder</h3>
                                    {this.state.bookingData!.holder.name + ' ' + this.state.bookingData!.holder.surname} <br />
                                    {this.state.customerData!.address} <br />
                                    {this.state.customerData!.postalCode} <br />
                                    {this.state.customerData!.city} <br />
                                    {this.state.customerData!.state} <br />
                                    Email : <a href={mailto}> {this.state.customerData!.email}</a>
                                </div>
                            </div>
                            <div className='col-md-2'>
                                <span />
                            </div>
                            <div className='col-md-6  '>
                                <table className='table book table-striped' style={{ border: '1px solid #eee', padding: 10, marginTop: 15 }}>
                                    <tr>
                                        <td colSpan={3} style={{ verticalAlign: 'top', textAlign: 'left' }}>
                                            <h3>
                                                <a href={getHotelSlug(this.state.bookingData!.hotel.name, this.state.bookingData!.hotel.code)}>  <h3>{this.state.bookingData!.hotel.name}
                                                    <CategoryHotels
                                                        key={'stars'}
                                                        star={this.state.bookingData!.hotel.Category!.simpleCode!} 
                                                    /> </h3>
                                                </a>
                                            </h3>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ verticalAlign: 'top', textAlign: 'left' }} >Booking Id</td>
                                        <td style={{ verticalAlign: 'top', textAlign: 'left' }}>:</td>
                                        <td>{this.state.bookingData!.clientReference}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ verticalAlign: 'top', textAlign: 'left' }}>Reference No</td>
                                        <td style={{ verticalAlign: 'top', textAlign: 'left' }}>:</td>
                                        <td>{this.state.bookingData!.reference}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ verticalAlign: 'top', textAlign: 'left' }}>Booking Date</td>
                                        <td style={{ verticalAlign: 'top', textAlign: 'left' }}>:</td>
                                        <td>{this.state.bookingData!.creationDate}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ verticalAlign: 'top', textAlign: 'left' }}>Booking Status</td>
                                        <td style={{ verticalAlign: 'top', textAlign: 'left' }}>:</td>
                                        <td>
                                            {this.state.bookingData!.modificationPolicies.cancellation ? <span className='REFUNDABLE'>REFUNDABLE</span> : <span />} <br />
                                            {this.state.bookingData!.modificationPolicies.modification ? <span className='REFUNDABLE'>MODIFIABLE</span> : <span />}
                                        </td>
                                    </tr>
                                </table>

                            </div>
                        </div>
                        <div className='col-md-12 '>
                            <hr style={{ margin: '10px 0px' }} />
                        </div>
                        <div className='col-md-12'>
                            <div className='col-md-4'>
                                <img src="/assets/images/calender.png" style={{ float: 'left', marginTop: 5, height: 40 }} />
                                <div style={{ margin: '5px 0px 0px 80px' }}>
                                    Check In <br />
                                    <h3 style={{ fontWeight: 500, color: '#03aeef', fontSize: 20 }}>{momentWrapper(this.state.bookingData!.hotel.checkIn).format('MMMM Do YYYY')}</h3>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <img src="/assets/images/calender.png" style={{ float: 'left', marginTop: 5, height: 40 }} />
                                <div style={{ margin: '5px 0px 0px 80px' }}>
                                    Check Out  <br />
                                    <h3 style={{ fontWeight: 500, color: '#03aeef', fontSize: 20 }}>{momentWrapper(this.state.bookingData!.hotel.checkOut).format('MMMM Do YYYY')}</h3>
                                </div>
                            </div>
                            <div className='col-md-4  '>
                                <img src="/assets/images/info.png" style={{ float: 'left', marginTop: 5, height: 40 }} />
                                <div style={{ margin: '12px 0px 0px 80px' }}>
                                    <span style={{ background: '#03aeef', fontSize: 20, color: '#fff', padding: '4px 20px', borderRadius: 10 }} > {this.state.bookingData!.status} </span>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-12 '>
                            <hr style={{ margin: '10px 0px' }} />
                        </div>
                        <div className='col-md-12' style={{ padding: '10px 10px ' }}>
                            <div className='col-md-12' style={{ fontSize: 20, fontWeight: 300, color: '#03aeef' }}>
                                This voucher entitles the guest to the accommodation and services as Rated below:
                                </div>
                        </div>
                        <div className='col-md-12 '>
                            {this.renderRoomDetail(this.state.bookingData!.hotel.rooms!)}
                        </div>
                        <div className='col-md-12 '>
                            <hr style={{ margin: '10px 0px' }} />
                        </div>
                        <div className='col-md-12 '>
                            <h3 style={{ color: 'red' }}> Cancellation Amount for today :  {new FormatterUtils().formatMoney(this.state.cancelationData!.hotel.cancellationAmount * this.state.curencyValue!, this.state.curencyCode!, true)}     </h3>
                        </div>
                        <div className='col-md-12 '>
                            <form onSubmit={this.submitCancelationBooking}>
                                <button className='btn btn-wide btn-warning' style={{ float: 'right' }}> Cancel Your Booking With Value {this.state.curencyCode} {new FormatterUtils().formatMoney(this.state.cancelationData!.hotel.cancellationAmount * this.state.curencyValue!, this.state.curencyCode!, true, false)} </button>
                            </form>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <h3>Search Hotel</h3>
                        <SearchForm
                            lang={this.props.lang}
                            showtitle={false}
                            style='vertical'
                            count={15}
                            getHotels={this.props.getHotels}
                            externalFilter={{}}
                            filter={this.props.initialFilter}
                            /* key={btoa(JSON.stringify(this.props.initialFilter))} */
                        />
                        <RecentBlog lang={this.props.lang} />
                    </div>
                </div>
            </section>
        );
    }

    private checkCancelationConfirmed: () => any = () => {
        getAjaxhelper().get(`/dynamics/rest-api/generic/BookingCancelation/${this.state.currentBookingCancelationId}`).then(
            d => {
                this.setStateHelper(
                    st => {
                        if (this.recLagi === 10) {

                            st.haveError = true;
                            st.errorCode = 'SERVER_NOT_ANSWER';
                            st.errorMessage = "Internal Server Error, Server not answer your booking cancelation yet. if server not send you email booking cancelation confirmed please tray again letter";
                        }
                        if (d.dataStatus !== 'COMPLETE') {
                            // this.timeout = setTimeout(this.checkCancelationConfirmed, 10000);
                            // this.recLagi++;
                        } else {
                            st.panelState = 'canceled';
                        }
                    },
                    () => {
                        if (d.dataStatus !== 'COMPLETE') {
                            this.timeout = setTimeout(this.checkCancelationConfirmed, 10000);
                            this.recLagi++;
                        }
                    });

            }
        );
    }
    private submitCancelationBooking: (event: any) => any = (event: any) => {
        event.preventDefault();
        getAjaxhelper().get(`/dynamics/rest-api/generic/BookingCancelation/${this.state.currentBookingCancelationId}`).then(
            d => {
                let token = d.requestToken;
                getAjaxhelper().get(`/dynamics/booking-cancelation/verify-cancel/${token}`).then(
                    e => {
                        if (e.status === 'VERIFIED') {
                            this.setState(
                                { panelState: 'waiting' },
                                () => {
                                    if (this.timeout) {
                                        clearTimeout(this.timeout);
                                        this.timeout = null;
                                    }
                                    this.recLagi = 0;
                                    this.checkCancelationConfirmed();
                                });
                        } else {
                            this.setStateHelper(
                                st => {
                                    st.haveError = true;
                                    st.errorCode = 'SERVER_NOT_RESPON';
                                    st.errorMessage = "Internal Server Error, Our server not response you cancelation request";
                                }
                            );
                        }
                    }
                ).catch(exc => {
                    this.setStateHelper(
                        st => {
                            st.haveError = true;
                            st.errorCode = exc.code;
                            st.errorMessage = exc.message;
                        }
                    );
                });
            }
        ).catch(exc => {
            this.setStateHelper(
                st => {
                    st.haveError = true;
                    st.errorCode = exc.code;
                    st.errorMessage = exc.message;
                }
            );
        });
    }

}


// WEBPACK FOOTER //
// ./src/new-booking/BookingCancelationConfirmation.tsx